import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var overlayStyle = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_19epc5k2',variantClassNames:{overlayTheme:{light:'fx_2d2fb1e5_19epc5k3',dark:'fx_2d2fb1e5_19epc5k4',transparent:'fx_2d2fb1e5_19epc5k5'}},defaultVariants:{},compoundVariants:[]});

export { overlayStyle };
//# sourceMappingURL=overlay.vanilla.mjs.map
